import tippy from "tippy.js";
import { Z_INDEX } from "~/jose_modern/hint_util.js";
import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { onceEach } from "~/jose_modern/once.js";
import { initEditTitle } from "../shared/edit_title.js";

let shipButtons = [];
let itemsEmpty = true;
let hasUnsaved = false;
let missingLotCodes = 0;

function disabledReason(action) {
  if (itemsEmpty) return `Add at least one item to ${action}`;
  if (hasUnsaved) return `Save all items before ${action === "ship" ? "shipping" : "activating"}`;
  if (action === "ship" && missingLotCodes > 0) return "Give every item a lot code before shipping";

  return null;
}

function updateShipButtons() {
  shipButtons = shipButtons.filter(({ button, hint }) => {
    if (button.isConnected) return true;

    hint.destroy();
    return false;
  });

  shipButtons.forEach(({ button, hint, action }) => {
    const reason = disabledReason(action);
    button.disabled = Boolean(reason);

    if (reason) {
      hint.setContent(reason);
      hint.enable();
    } else {
      hint.disable();
    }
  });
}

function initShipButtons(container) {
  const buttons = container.querySelectorAll("[data-ship-button], [data-activate-button]");
  onceEach(buttons, "ship-button", (button) => {
    const action = button.hasAttribute("data-ship-button") ? "ship" : "activate";
    const wrapper = document.createElement("span");
    wrapper.style.display = "inline-block";
    button.parentNode.insertBefore(wrapper, button);
    wrapper.appendChild(button);

    const hint = tippy(wrapper, {
      theme: "recipal",
      appendTo: document.body,
      zIndex: Z_INDEX,
    });

    shipButtons.push({ button, hint, action });
  });

  updateShipButtons();
}

onViewLoad("shipments#edit", () => {
  // We get one of each event once the items table is mounted, making sure
  // the states are always in sync
  document.addEventListener("shipment-items-changed", ({ detail }) => {
    itemsEmpty = detail.count === 0;
    updateShipButtons();
  });

  document.addEventListener("shipment-items-has-unsaved", ({ detail }) => {
    hasUnsaved = detail.hasUnsaved;
    updateShipButtons();
  });

  document.addEventListener("shipment-items-missing-lot-codes", ({ detail }) => {
    missingLotCodes = detail.missing;
    updateShipButtons();
  });

  initShipButtons(document);
  initEditTitle(document);

  document.addEventListener("partial:replace", (ev) => {
    initShipButtons(ev.container);
    initEditTitle(ev.container);
  });
});
